/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import api from "../../utils/api";
import { Link, useLocation, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import {
  FiHome,
  FiChevronRight,
  FiFileText,
  FiType,
  FiPlus,
  FiTrash2,
  FiSave,
  FiX,
  FiGrid,
  FiBookOpen
} from 'react-icons/fi';

const Template = ({ onTemplateCreated }) => {
  const location = useLocation();
  const editTemplateData = location.state?.template || null;
  const [selectedModule, setSelectedModule] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [modules, setModules] = useState([]);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [subjectInputs, setSubjectInputs] = useState({});
  const [error, setError] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [questionType, setQuestionType] = useState([]);
  const [selectedQuestionType, setSelectedQuestionType] = useState("");
  const [questionTypes, setQuestionTypes] = useState([]);
  const [templateData, setTemplateData] = useState(null);
  const [selectedQuestionTypes, setSelectedQuestionTypes] = useState({});
  const [loading, setLoading] = useState(false);
  const [userPermissions, setUserPermissions] = useState({});
  const [selectedSubjectsPerSection, setSelectedSubjectsPerSection] = useState({});

  const { id } = useParams();

  useEffect(() => {
    auth();
  }, []);

  async function auth() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getPagePermission";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);
      fd.append("pageNo", 11);

      const response = await api.post("user/userCurl", fd);
      if (response.data && response.data.data.length > 0) {
        setUserPermissions(response.data.data[0]);
      }
    } catch (error) {
      setUserPermissions({});
      toast.error("Error fetching permissions.");
    } finally {
      setLoading(false);
    }
  }

  async function fetchModules() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getAllDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const modulesResponse = await api.post("module/moduleCurl", fd);
      setModules(
        Array.isArray(modulesResponse.data.getResponse)
          ? modulesResponse.data.getResponse
          : []
      );
    } catch (error) {
      setModules([]);
    }
  }

  async function fetchCourses(moduleId) {
    if (!moduleId) return setCourses([]);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getCourseOnchange";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("id", moduleId);

      const courseResponse = await api.post("onchange/onchangeCurl", fd);
      setCourses(Array.isArray(courseResponse.data) ? courseResponse.data : []);
    } catch (error) {
      setCourses([]);
    }
  }

  async function fetchSubjects() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getAllDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const subjectResponse = await api.post("subject/subjectCurl", fd);
      const subjectData = Array.isArray(subjectResponse.data.getSubjectDetails)
        ? subjectResponse.data.getSubjectDetails
        : [];

      setSubjects(subjectData);

      const inputs = {};
      subjectData.forEach((section) => {
        if (section.subjects) {
          section.subjects.forEach((subject) => {
            for (
              let sectionIndex = 0;
              sectionIndex < subjectData.length;
              sectionIndex++
            ) {
              const inputKey = `${subject.subjectName}_section_${sectionIndex}`;
              inputs[inputKey] = {
                questions: "",
                compulsory: subject.compulsory || "",
                optional: subject.optional || "",
                positive: subject.positive || "",
                negative: subject.negative || "",
              };
            }
          });
        }
      });
      setSubjectInputs(inputs);
    } catch (error) {
      setSubjects([]);
    }
  }

  async function fetchQuestionType() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getAllDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("questionType/questionTypeCurl", fd);
      if (Array.isArray(response.data.getQuestionTypeDetails)) {
        setQuestionTypes(response.data.getQuestionTypeDetails);
      } else {
        setQuestionTypes([]);
      }
    } catch (error) {
      // console.error("Error submitting form:", error);
    }
  }

  const handleInputChange = (key, field, value) => {
    setSubjectInputs((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
  };

  const handleEditTemplate = async () => {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getTemplateDetailsForUpdate";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("id", id);

    try {
      const response = await api.post("templates/templateCurl", fd);
      if (response?.data?.length > 0) {
        const template = response.data[0];
        const details = template.details ? JSON.parse(template.details) : {};

        setTemplateData(template);
        setTemplateName(details.template?.templateName || "");
        setSelectedModule(details.template?.module || "");
        setSelectedCourse(details.template?.course || "");
        setSelectedSection(details.template?.totalSections || "");

        const firstSection = Object.keys(details.sections || {})[0];
        if (firstSection && details.sections[firstSection]?.questionType) {
          setSelectedQuestionType(details.sections[firstSection].questionType);
        }

        let formattedInputs = {};
        if (details.sections) {
          Object.entries(details.sections).forEach(
            ([sectionIndex, section]) => {
              if (section.subjects) {
                Object.values(section.subjects).forEach((subject) => {
                  const key = `${subject.subjectName.trim()}_section_${sectionIndex}`;

                  formattedInputs[key] = {
                    questions: subject.noOfQuestions || "0",
                    compulsory: subject.compulsory || "0",
                    optional: subject.optional || "0",
                    positive: subject.positive || "0",
                    negative: subject.negative || "0",
                  };
                });
              }
            }
          );
        }
        setSubjectInputs(formattedInputs);
      }
    } catch (error) {
      // console.error("Error fetching data for editing template:", error);
    }
  };

  useEffect(() => {
    if (selectedModule) {
      fetchCourses(selectedModule);
    }
  }, [selectedModule]);

  useEffect(() => {
    fetchSubjects();
  }, []);

  useEffect(() => {
    handleEditTemplate();
  }, [id]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (subjects.length === 0) {
      setLoading(false);
      toast.error("At least one subject must be added before submitting.");
      return;
    }

    const hasValidData = Object.values(subjectInputs).some(
      (input) => Number(input.questions) > 0
    );

    if (!hasValidData) {
      toast.error(
        "At least one subject must have a valid number of questions."
      );
      setLoading(false);
      return;
    }

    if (!templateName.trim()) {
      setLoading(false);
      toast.error("Template Name is required.");
      return;
    }

    if (!selectedSection) {
      setLoading(false);
      toast.error("Section selection is required.");
      return;
    }

    for (
      let sectionIndex = 0;
      sectionIndex < parseInt(selectedSection);
      sectionIndex++
    ) {
      const sectionKey = `${subjects[0]?.subjectName}_section_${sectionIndex}`;
      const positiveMarks = subjectInputs[sectionKey]?.positive;
      const negativeMarks = subjectInputs[sectionKey]?.negative;

      if (!positiveMarks || !negativeMarks) {
        toast.error(
          `Please enter positive and negative marks for Section ${sectionIndex + 1}.`
        );
        setLoading(false);
        return;
      }
    }

    for (let i = 0; i < parseInt(selectedSection); i++) {
      if (!selectedQuestionTypes[i]) {
        setLoading(false);
        toast.error(`Please select a question type for Section ${i + 1}.`);
        return;
      }
    }

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "addTemplate";

    const sections = Array.from({ length: parseInt(selectedSection) || 0 }).map(
      (_, sectionIndex) => {
        const sectionSubjects = subjects.map((subject) => {
          const inputKey = `${subject.subjectName}_section_${sectionIndex}`;
          const inputs = subjectInputs[inputKey] || {};
          return {
            subjectId: subject.id,
            subjectName: subject.subjectName,
            noOfQuestions: inputs.questions || 0,
            compulsory: inputs.compulsory || 0,
            optional: inputs.optional || 0,
          };
        });

       const qTypeId = selectedQuestionTypes[sectionIndex];

const qTypeObj = questionTypes.find(
  (qt) => String(qt.id) === String(qTypeId)
);

return {
  sectionNumber: sectionIndex + 1,
  questionType: qTypeId,
  questionTypeName: qTypeObj?.questionType || "", // ✅ ADD THIS
  positive:
    subjectInputs[`${subjects[0]?.subjectName}_section_${sectionIndex}`]
      ?.positive || "",
  negative:
    subjectInputs[`${subjects[0]?.subjectName}_section_${sectionIndex}`]
      ?.negative || "",
  subjects: sectionSubjects,
};
      }
    );

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("module", selectedModule);
    fd.append("course", selectedCourse);
    fd.append("templateName", templateName);
    fd.append("sections", JSON.stringify(sections));
    fd.append("noOfSections", sections.length);

    try {
      const response = await api.post("templates/templateCurl", fd);
      if (response.data.status === true) {
        toast.success(response.data.data);

        if (onTemplateCreated) {
          onTemplateCreated();
        }
        setTemplateName("");
        setSelectedModule("");
        setSelectedCourse("");
        setSelectedSection("");
        setSubjects([]);
        setSubjectInputs({});
      } else {
        toast.error(response.data.data);
      }
    } catch (error) {
      setError("Error adding template. Please try again.");
      toast.error("Error adding template. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchModules();
    fetchQuestionType();
  }, []);

  useEffect(() => {
    const newSelected = {};
    for (let i = 0; i < parseInt(selectedSection || 0); i++) {
      newSelected[i] = [];
    }
    setSelectedSubjectsPerSection(newSelected);
  }, [selectedSection]);

  const subjectOptions = subjects.map((subject) => ({
    value: subject.subjectName,
    label: subject.subjectName,
  }));

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      border: "1px solid #e5e7eb",
      borderRadius: "0.5rem",
      padding: "0.25rem",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#3b82f6",
      },
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,          // ⭐ REQUIRED
    }),

    menu: (base) => ({
      ...base,
      borderRadius: "0.5rem",
      border: "1px solid #e5e7eb",
      boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
      zIndex: 9999,
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#3b82f6"
        : state.isFocused
          ? "#f3f4f6"
          : "white",
      color: state.isSelected ? "white" : "#374151",
      cursor: "pointer",
    }),
  };


  return (
    <div className="dashboard-body">
      <style>
        {`
          .template-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
            padding: 1.5rem;
          }

          .breadcrumb {
            padding: 1rem 0;
            margin-bottom: 1.5rem;
          }

          .breadcrumb-list {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .breadcrumb-list li {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .breadcrumb-item {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            color: #6b7280;
            text-decoration: none;
            font-size: 0.875rem;
            transition: color 0.2s;
          }

          .breadcrumb-item:hover {
            color: #3b82f6;
          }

          .breadcrumb-item.active {
            color: #1f2937;
            font-weight: 500;
          }

          .form-card {
            background: white;
            border-radius: 1rem;
            border: 1px solid #e2e8f0;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  overflow: visible;
            margin-bottom: 1.5rem;
          }

          .card-header {
            padding: 1.25rem 1.5rem;
            border-bottom: 1px solid #f3f4f6;
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          }

          .card-header h3 {
            font-size: 1.125rem;
            font-weight: 600;
            color: #1f2937;
            margin: 0 0 0.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .card-subtitle {
            font-size: 0.875rem;
            color: #6b7280;
            margin: 0;
          }

          .card-content {
            padding: 1.5rem;
          }

          .form-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 1.5rem;
          }

          .form-group {
            margin-bottom: 1rem;
          }

          .form-label {
            display: block;
            font-size: 0.875rem;
            font-weight: 600;
            color: #374151;
            margin-bottom: 0.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .required {
            color: #ef4444;
            font-weight: 600;
          }

          .form-control, .form-select {
            width: 100%;
            padding: 0.625rem 0.875rem;
            border: 1px solid #e5e7eb;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            color: #374151;
            background: white;
            transition: all 0.2s;
          }

          .form-control:focus, .form-select:focus {
            outline: none;
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          }

          .section-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 1rem 1.5rem;
            background: #f9fafb;
            border-bottom: 1px solid #e5e7eb;
          }

          .section-title {
            font-size: 1rem;
            font-weight: 600;
            color: #374151;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .section-controls {
            display: flex;
            align-items: center;
            gap: 1rem;
          }

          .marks-input-group {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .marks-input {
            width: 120px;
            padding: 0.5rem 0.75rem;
            border: 1px solid #e5e7eb;
            border-radius: 0.375rem;
            font-size: 0.875rem;
          }

          .subject-table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
          }

          .subject-table thead {
            background: #f9fafb;
          }

          .subject-table th {
            padding: 0.75rem 1rem;
            font-size: 0.875rem;
            font-weight: 600;
            color: #374151;
            text-align: left;
            border-bottom: 2px solid #e5e7eb;
          }

          .subject-table td {
            padding: 0.75rem 1rem;
            border-bottom: 1px solid #f3f4f6;
          }

          .subject-table tr:hover {
            background: #f9fafb;
          }

          .btn {
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.625rem 1.25rem;
            border: none;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
          }

          .btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          .btn-primary {
            background: #3b82f6;
            color: white;
          }

          .btn-primary:hover:not(:disabled) {
            background: #2563eb;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
          }

          .btn-danger {
            background: #ef4444;
            color: white;
          }

          .btn-danger:hover:not(:disabled) {
            background: #dc2626;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
          }

          .btn-success {
            background: #10b981;
            color: white;
          }

          .btn-success:hover:not(:disabled) {
            background: #059669;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
          }

          .form-actions {
            display: flex;
            justify-content: flex-end;
            gap: 1rem;
            padding: 1.5rem;
            background: white;
            border-radius: 1rem;
            border: 1px solid #e2e8f0;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            margin-top: 1.5rem;
          }

          .spinner {
            width: 16px;
            height: 16px;
            border: 2px solid rgba(255, 255, 255, 0.3);
            border-radius: 50%;
            border-top-color: white;
            animation: spin 1s linear infinite;
            margin-right: 0.5rem;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }

          .input-group {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .input-icon {
            color: #9ca3af;
            width: 20px;
            height: 20px;
          }

          @media (max-width: 768px) {
            .template-container {
              padding: 1rem;
            }

            .form-grid {
              grid-template-columns: 1fr;
            }

            .section-controls {
              flex-direction: column;
              align-items: stretch;
              gap: 0.5rem;
            }

            .marks-input-group {
              justify-content: space-between;
            }

            .marks-input {
              flex: 1;
            }

            .subject-table {
              display: block;
              overflow-x: auto;
            }

            .form-actions {
              flex-direction: column;
            }

            .btn {
              width: 100%;
              justify-content: center;
            }
          }
        `}
      </style>

      {userPermissions.is_view === "0" ? (
        <div className="text-center mt-5">
          <h4 className="text-danger">Permission Denied</h4>
        </div>
      ) : (
        <>


          <div className="form-card">
            <div className="card-header">
              <h3><FiFileText /> Create New Template</h3>
              <p className="card-subtitle">Define your template structure with sections and subjects</p>
            </div>

            <div className="card-content">
              {error && <div className="alert alert-danger">{error}</div>}

              <form onSubmit={handleSubmit}>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="templateName" className="form-label">
                      <FiFileText /> Template Name <span className="required">*</span>
                    </label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Template Name"
                        value={templateName}
                        onChange={(e) => setTemplateName(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="section" className="form-label">
                      <FiGrid /> Number of Sections <span className="required">*</span>
                    </label>
                    <select
                      className="form-select"
                      value={selectedSection}
                      onChange={(e) => setSelectedSection(e.target.value)}
                    >
                      <option value="">Select Sections</option>
                      {[...Array(20)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1} Section{i + 1 !== 1 ? 's' : ''}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {Array.from({ length: parseInt(selectedSection) || 0 }).map(
            (_, sectionIndex) => (
              <div key={sectionIndex} className="form-card">
                <div className="section-header">
                  <div className="section-title">
                    <FiBookOpen /> Section {sectionIndex + 1}
                  </div>

                  <div className="section-controls">
                    <div className="marks-input-group">
                      <input
                        type="number"
                        name={`positive_section_${sectionIndex}[]`}
                        className="marks-input"
                        placeholder="+ Marks"
                        value={
                          subjectInputs[
                            `${subjects[0]?.subjectName}_section_${sectionIndex}`
                          ]?.positive || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            `${subjects[0]?.subjectName}_section_${sectionIndex}`,
                            "positive",
                            e.target.value
                          )
                        }
                      />
                      <input
                        type="number"
                        name={`negative_section_${sectionIndex}[]`}
                        className="marks-input"
                        placeholder="- Marks"
                        value={
                          subjectInputs[
                            `${subjects[0]?.subjectName}_section_${sectionIndex}`
                          ]?.negative || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            `${subjects[0]?.subjectName}_section_${sectionIndex}`,
                            "negative",
                            e.target.value
                          )
                        }
                      />
                    </div>

                    <select
                      className="form-select"
                      style={{ width: '200px' }}
                      value={selectedQuestionTypes[sectionIndex] || ""}
                      onChange={(e) => {
                        setSelectedQuestionTypes((prev) => ({
                          ...prev,
                          [sectionIndex]: e.target.value,
                        }));
                      }}
                    >
                      <option value="">
                        <FiType /> Question Type <span className="required">*</span>
                      </option>
                      {questionTypes.map((questionType) => (
                        <option
                          key={questionType.id}
                          value={questionType.id}
                        >
                          {questionType.questionType}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="card-content">
                  <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                    <label className="form-label">
                      <FiPlus /> Select Subjects for this Section
                    </label>
                    <Select
                      isMulti
                      options={subjectOptions}
                      value={(selectedSubjectsPerSection[sectionIndex] || []).map((subjectName) => ({
                        value: subjectName,
                        label: subjectName,
                      }))}
                      onChange={(selectedOptions) => {
                        const selected = selectedOptions.map((option) => option.value);

                        setSelectedSubjectsPerSection((prev) => ({
                          ...prev,
                          [sectionIndex]: selected,
                        }));

                        const updatedInputs = { ...subjectInputs };
                        selected.forEach((subjectName) => {
                          const key = `${subjectName}_section_${sectionIndex}`;
                          if (!updatedInputs[key]) {
                            updatedInputs[key] = {
                              questions: "",
                              compulsory: "",
                              optional: "",
                              positive: "",
                              negative: "",
                            };
                          }
                        });
                        setSubjectInputs(updatedInputs);
                      }}
                      placeholder="Select subjects..."
                      styles={customSelectStyles}
                      menuPortalTarget={document.body}   // ⭐ KEY FIX
                    />

                  </div>

                  {(selectedSubjectsPerSection[sectionIndex] || []).length > 0 && (
                    <div className="table-responsive">
                      <table className="subject-table">
                        <thead>
                          <tr>
                            <th>Subject</th>
                            <th>No. of Questions</th>
                            <th>Compulsory</th>
                            <th>Optional</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(selectedSubjectsPerSection[sectionIndex] || []).map(
                            (subjectName, index) => (
                              <tr key={`${sectionIndex}-${index}`}>
                                <td style={{ fontWeight: '500' }}>{subjectName}</td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter number"
                                    value={
                                      subjectInputs[
                                        `${subjectName}_section_${sectionIndex}`
                                      ]?.questions || ""
                                    }
                                    onChange={(e) =>
                                      handleInputChange(
                                        `${subjectName}_section_${sectionIndex}`,
                                        "questions",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Compulsory"
                                    value={
                                      subjectInputs[
                                        `${subjectName}_section_${sectionIndex}`
                                      ]?.compulsory || ""
                                    }
                                    onChange={(e) =>
                                      handleInputChange(
                                        `${subjectName}_section_${sectionIndex}`,
                                        "compulsory",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Optional"
                                    value={
                                      subjectInputs[
                                        `${subjectName}_section_${sectionIndex}`
                                      ]?.optional || ""
                                    }
                                    onChange={(e) =>
                                      handleInputChange(
                                        `${subjectName}_section_${sectionIndex}`,
                                        "optional",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() =>
                                      setSelectedSubjectsPerSection((prev) => ({
                                        ...prev,
                                        [sectionIndex]: prev[sectionIndex].filter(
                                          (s) => s !== subjectName
                                        ),
                                      }))
                                    }
                                  >
                                    <FiTrash2 />
                                  </button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            )
          )}

          {parseInt(selectedSection) > 0 && (
            <div className="form-actions">
              <button
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="spinner"></div>
                    Submitting...
                  </>
                ) : (
                  <>
                    <FiSave /> Submit Template
                  </>
                )}
              </button>
            </div>
          )}
        </>
      )}
      <ToastContainer />
    </div>
  );
};

export default Template;